/**
 * Copyright © OXID eSales AG. All rights reserved.
 * See LICENSE file for license details.
 */

// import ace from '../ace/index.js';
import '../../styles/backend/backend.less'
import '../../styles/backend/admin_ui.less'
import '../../styles/backend/bootstrap3.less'

import 'gridstack/dist/gridstack.css'
import 'gridstack/dist/gridstack-extra.css'
import 'jstree/dist/themes/default/style.css'
import 'selectize/dist/css/selectize.bootstrap3.css'

import { initAceEditor, registerAceEditor } from "./less-css-editor.js";
import { registerTreeView } from "./treeview.js";
import { registerTemplateEvents } from "./template.js";
import { preload, resize } from "./grid.js";
import { installDemoData, timeStampActivate } from "./panel.js";
import {registerPreviewEvents} from "./preview.js";

// Window Events
// -------------
window.addEventListener("load", () => {
    preload();
});

window.addEventListener("resize", () => {
    resize();
});

// Document Ready
// --------------
document.addEventListener("DOMContentLoaded", () => {
    registerTemplateEvents();

    // Timespan activation
    $('.dd-veditor-timespan-toggle').on('click', function () {
        timeStampActivate();
    });

    // Demodata section
    $('.dd-demodata-action').on('click', function () {
        installDemoData();
    });

    registerAceEditor();

    registerTreeView();

    initAceEditor();

    registerPreviewEvents();

    let ddh = window.ddh;
});
